module.exports = __webpack_public_path__ + "static/media/cabo-flat.1c96b5a4.png";